import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import type { TemplateWithPlainImagesFrame } from 'hb-builder/components/BuilderComponents/block/Strips/types/items';
import type {
  Elements,
  FieldDisplaySelectProps,
  FieldsDrawerProps,
} from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';

const FieldsDrawer = ({
  canHideImage,
  item,
  onChange,
}: FieldsDrawerProps<TemplateWithPlainImagesFrame['children']>) => {
  const [firstImage, firstWrapper, firstButton] = item;
  const [firstHeadline, firstSubline] = firstWrapper.children || [];

  const elements = (
    [
      canHideImage && {
        identifier: 'image',
        item: firstImage,
        label: s__('Builder|Image'),
      },
      {
        identifier: 'headline',
        item: firstHeadline,
        label: s__('Builder|Headline'),
      },
      {
        identifier: 'subline',
        item: firstSubline,
        label: s__('Builder|Subline'),
      },
      { identifier: 'button', item: firstButton, label: s__('Builder|Button') },
    ] as Elements
  ).filter(Boolean);

  const fields = elements.map(({ identifier, item, label }, index) => (
    <FieldDisplaySelect
      identifier={identifier}
      isLast={index === elements.length - 1}
      item={item}
      label={label}
      key={identifier}
      onChange={onChange}
    />
  ));

  return <AccordionTitle title={__('Fields')}>{fields}</AccordionTitle>;
};

const FieldDisplaySelect = ({
  identifier,
  isLast,
  item,
  label,
  onChange,
}: FieldDisplaySelectProps) => (
  <Box flexDirection="column" mb={isLast ? 3 : undefined}>
    <DisplayOption
      item={item}
      title={label}
      onChange={({ settingKey, value }) =>
        onChange({ element: identifier, settingKey, value })
      }
    />
    {!isLast && <Divider mb={3} mt={2} />}
  </Box>
);

export default FieldsDrawer;
